import * as actionTypes from "../actionTypes/actionTypes";

const onModelSelected = (option) => {
    return (dispatch) => {
      dispatch({
        type: actionTypes.SELECTED_MODEL,
        payload: option
      })
    }
  }

  const onDrawingSelected = (option) => {
    return (dispatch) => {
      dispatch({
        type: actionTypes.SELECTED_PAGE_DRAWING,
        payload: option
      })
    }
  }

  const onCloseSelected = (option) => {
    return (dispatch) => {
      dispatch({
        type: actionTypes.SET_CLOSE_MODEL,
        payload: option
      })
    }
  }

const onTabSelected = (tabId) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SELECTED_TAB,
      payload: tabId 
    })
  }
}

const setSnackBar = (show, severity, message) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_SNACKBAR,
      payload: {show, severity, message}
    })
  }
}

const breadCrumbSettingAction = (option) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SETTING_BREDCRUMB,
      payload: option
    })
  }  
}

export { onModelSelected, onTabSelected, setSnackBar, onDrawingSelected, onCloseSelected,breadCrumbSettingAction };
